// AI-CONTEXT: See docs/patterns.md#hook-permission-gate
//
// Starter roles offered when creating a new role. Permission lists are
// derived from the catalog so they never drift when keys are added.

import permissionsCatalog from './permissionsCatalog'

const allKeys = permissionsCatalog.map((p) => p.key)
const viewKeys = allKeys.filter((k) => k.endsWith('.view'))
const editKeys = allKeys.filter((k) => k.endsWith('.edit'))

// Keys reserved for administrators — excluded from non-admin presets.
const adminKeys = ['roles.manage', 'team.invite', 'team.delete', 'settings.edit', 'data.edit', 'data.export']

// Tarieven en facturatie zijn niet voor elke begeleider (docs/features/facturatie-per-deelnemer.md):
// alleen de Beheerder krijgt ze vanzelf, andere rollen pas als een beheerder ze aanzet.
const isBilling = (k) => k.startsWith('billing.')

const contentEditKeys = editKeys.filter((k) => !adminKeys.includes(k) && !isBilling(k))
const contentViewKeys = viewKeys.filter((k) => !isBilling(k))

const rolePresets = [
    {
        id: 'beheerder',
        name: 'Beheerder',
        description: 'Volledige rechten — kan alles bekijken, bewerken en beheren.',
        permissions: allKeys,
    },
    {
        id: 'teamlid',
        name: 'Teamlid',
        description: 'Bekijken en bewerken van de inhoud, geen beheertaken.',
        permissions: [...contentViewKeys, ...contentEditKeys],
    },
    {
        id: 'lezer',
        name: 'Lezer',
        description: 'Alles bekijken, niets bewerken.',
        permissions: [...contentViewKeys],
    },
    {
        id: 'begeleider-geen-personas',
        name: 'Begeleider zonder persona-inzage',
        description: 'Bekijken en bewerken, maar geen toegang tot personas.',
        permissions: [...contentViewKeys, ...contentEditKeys].filter((k) => !k.startsWith('personas.')),
    },
]

export default rolePresets
